export enum EOrderDetailsTabs {
	PRODUCT_LIST = 'productList',
	RESPOND_TO_THE_ORDER = 'respondToTheOrder',
}

export enum EOrderDetailsOrderSummary {
	ORDER_SUMMARY = 'orderSummary',
}

export enum EProductsBySupplierStatus {
	REQUEST_READY = 'request_ready',
	SUPPLIER_ASSIGNED = 'supplier_assigned',
	SUPPLIERS_TO_ASSIGN = 'suppliers_to_assign',
	REQUEST_SENT = 'request_sent',
	OFFER_UPLOADED = 'offer_uploaded',
	OFFER_ACCEPTED = 'offer_accepted',
	MERGED = 'merged',
}

export enum EProductsBySupplierMenuAction {
	ACCEPT = 'accept',
	REJECT = 'reject',
	CHANGE_SUPPLIER = 'changeSupplier',
}

export enum EPurchaseOrderItemSortBy {
	NAME = 'name',
	SUPPLIER = 'supplier',
	CATEGORY = 'category',
}

export enum EPurchaseOrderItemRemovalReason {
	STOCK_SECURED = 'stock_secured',
	WRONG_INDEX = 'wrong_index',
	DUPLICATED_POSITION = 'duplicated_position',
	CANCELLED_ACTION = 'cancelled_action',
	OTHER = 'other',
}

export const purchaseOrderItemRemovalReasonLabels: Record<EPurchaseOrderItemRemovalReason, string> = {
	[EPurchaseOrderItemRemovalReason.STOCK_SECURED]: 'Zapewniony stan magazynowy',
	[EPurchaseOrderItemRemovalReason.WRONG_INDEX]: 'Błąd indeksu',
	[EPurchaseOrderItemRemovalReason.DUPLICATED_POSITION]: 'Zdublowana pozycja',
	[EPurchaseOrderItemRemovalReason.CANCELLED_ACTION]: 'Anulowana akcja',
	[EPurchaseOrderItemRemovalReason.OTHER]: 'Inne',
}

export const purchaseOrderWarningLabels: Record<string, string> = {
	default_supplier_price_list_inactive: 'Cennik domyślnego dostawcy jest nieaktywny',
}
